<template>
  <div>
    <div class="main">
      <h2>
        倉庫（
        <span>{{ total }}</span> ）
      </h2>
      <div class="head">
        <p>
          <input type="checkbox" v-model="checked" @change="allChecked" />
          <span>ページ内すべてを選択</span>
          選択中
          {{ kindNum }}種類 {{ knNum }}点
        </p>
        <a href="javascript:;" @click="createDeliver">見積提出</a>
      </div>
      <div id="search">
        <div class="search fr">
          <input
            type="text"
            v-model="list.searchText"
            placeholder="注文書番号/受取人"
          />
          <a href="javascript:;" @click="storeList">確定</a>
        </div>
      </div>
      <div class="content">
        <div class="title">
          <div class="fanhao fl">注文番号</div>
          <ol>
            <li>選択</li>
            <li>NO</li>
            <li>写真</li>
            <li>サイズ</li>
            <li>カラー</li>
            <li>購入数</li>
            <li>発送数</li>
            <li>単価</li>
            <li>小計</li>
            <!-- <li>位置</li> -->
            <!-- <li class="flex3">オプション</li> -->
            <li>備考欄</li>
          </ol>
        </div>
        <h3 v-if="orderList == false">何も入っていません</h3>
        <div>
          <div
            class="containet"
            v-for="(item, index) in orderList"
            :key="index"
          >
            <div class="fanhao fl">
              <p>{{ item.ordno }}</p>
              <p>{{ item.addressRealname }}</p>
              <input
                type="checkbox"
                v-model="item.checked"
                @change="ordnoChecked(item, index)"
              />
            </div>
            <div class="ul">
              <ul v-for="(item1, index1) in item.product" :key="index1">
                <li>
                  <input
                    type="checkbox"
                    v-model="item1.checked"
                    @change="radioChecked(index, item1)"
                  />
                </li>
                <li>{{ item1.sorting }}</li>

                <li class="img">
                  <router-link
                    :to="
                      item1.type == 'rakumart'
                        ? '/details?id=' + item1.iid
                        : `/details1688?iid=${item1.iid}&type=${item1.type}${item1.mi_id ? '&mi_id=' + item1.mi_id : ''}`
                    "
                    target="_blank"
                  >
                    <img :src="item1.pic" class="item-img" alt />
                    <div class="img-box">
                      <img :src="item1.pic" alt />
                    </div>
                  </router-link>
                </li>
                <li>{{ item1.psize }}</li>
                <li>{{ item1.color }}</li>
                <li>{{ item1.rakusatu }}</li>
                <li>{{ item1.tocyaku }}</li>
                <li>{{ item1.price }}</li>
                <li>{{ item1.priceTotal }}</li>
                <!-- <li>A1</li> -->
                <!-- <li class="flex3">{{ item1.poption }}</li> -->
                <li class="beikao">
                  <img
                    src="../../../assets/img/beikao2.png"
                    alt
                    @click="beikao(index, index1)"
                  />
                  <div class="txt" v-show="item1.checked1">
                    <textarea
                      name
                      id
                      cols="25"
                      rows="9"
                      v-model="item1.bei"
                    ></textarea>
                    <div class="btn">
                      <a
                        href="javascript:;"
                        @click="
                          orderList[index].product[index1].checked1 = false
                        "
                        >閉じる</a
                      >
                      <a
                        href="javascript:;"
                        style="color: #fff; background: #f3c622"
                        @click="remark(item1, index, index1)"
                        >提出</a
                      >
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { storeList, storeEditRemark } from "../../../api/API/warehouse";
export default {
  data() {
    return {
      token: localStorage.getItem("token"),
      orderList: [], // 数据
      checked: false, //全选
      kindNum: 0, // 选择的种类
      knNum: 0, // 选中的可能发送数
      total: 0,
      ids: [], // 选中id
      list: {
        searchText: "",
        mod: "inc",
        act: "ordersys",
        str: "storeList",
        token: localStorage.getItem("token"),
      },
    };
  },
  created() {
    this.storeList();
  },
  methods: {
    // 获取数据
    storeList() {
      storeList(this.list).then((res) => {
        if (res.code != 1) return;
        this.orderList = res.data;
        this.total = res.data.length;
        console.log(res.data);
      });
    },
    // 全选
    allChecked() {
      if (this.checked == false) {
        this.orderList.forEach((item) => (item.checked = false));
      } else {
        this.orderList.forEach((item) => (item.checked = true));
      }
      this.ordnoChecked();
      this.totalNum();
    },
    // 单号选
    ordnoChecked() {
      if (this.orderList.every((item) => item.checked == true)) {
        this.checked = true;
      } else {
        this.checked = false;
      }
      this.orderList.forEach((item) => {
        if (item.checked == true) {
          item.product.forEach((item1) => {
            item1.checked = true;
          });
        } else {
          item.product.forEach((item1) => {
            item1.checked = false;
          });
        }
      });
      this.totalNum();
    },
    //单选
    radioChecked(index, item1) {
      var shop = this.orderList[index].product;
      var flag = shop.every((item, index) => item.checked == true);
      if (flag == true) {
        this.orderList[index].checked = true;
      } else {
        this.orderList[index].checked = false;
      }
      if (this.orderList.every((item) => item.checked == true)) {
        this.checked = true;
      } else {
        this.checked = false;
      }
      this.totalNum();
    },
    // 选中数
    totalNum() {
      this.kindNum = 0;
      this.knNum = 0;
      this.ids = [];
      this.orderList.forEach((item) => {
        item.product.forEach((item1) => {
          if (item1.checked == true) {
            this.kindNum += 1;
            this.knNum += item1.tocyaku - 0;
            this.ids.push(item1.id);
          }
        });
      });
    },
    // 备注提示
    beikao(index, index1) {
      this.orderList.forEach((item) => {
        item.product.forEach((item1) => {
          item1.checked1 = false;
        });
      });
      this.orderList[index].product[index1].checked1 = true;
    },
    //备注提交
    remark(item1, index, index1) {
      let list = {
        mod: "inc",
        act: "ordersys",
        str: "storeEditRemark",
        token: this.token,
        id: item1.id,
        remark: item1.bei,
      };
      console.log(list);

      storeEditRemark(list).then((res) => {
        if (res.code != 1) return this.$message.error("保存失败");
        //  this.orderList[index].product[index1].bei =
        this.orderList[index].product[index1].checked1 = false;

        this.$message.success("保存成功");
      });
    },
    // 生成配送单
    createDeliver() {
      if (this.ids == false) return this.$message.error("何も入っていません");
      this.ids = this.ids.join(",");
      this.storeList();
      this.checked = false;
      this.knNum = 0;
      this.kindNum = 0;
      let routeUrl = this.$router.resolve({
        path: "/deliver?ids=" + this.ids,
      });
      window.open(routeUrl.href, "_blank");
    },
    //搜索
    search() {},
  },
};
</script>
<style lang='scss' scoped>
.main {
  width: 1208px;
  //   height: 1000px;
  font-size: 16px;
  h2 {
    height: 40px;
    background-color: #eee;
    line-height: 40px;
    padding-left: 20px;
    font-size: 20px;
    span {
      color: #f3c622;
    }
  }
  .head {
    height: 30px;
    background: #edf0fc;
    padding: 5px 10px;
    border: 1px solid #ccc;

    p {
      float: left;
      font-size: 12px;
      line-height: 30px;
      input {
        height: 18px;
        width: 20px;
        vertical-align: middle;
      }
      span {
        font-weight: 700;
      }
    }
    a {
      float: right;
      margin: 0px 30px 0 0;
      background: #f3c622;
      color: #fff;
      width: 100px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-radius: 5px;
    }
  }
  .content {
    border: 1px solid #ccc;

    text-align: center;
    .fanhao {
      width: 198px;
      line-height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-flow: column;
    }
    .title {
      border-bottom: 1px solid #ccc;
      height: 30px;

      ol {
        width: 1006px;
        float: left;
        height: 30px;
        display: flex;
        li {
          text-align: center;
          line-height: 30px;
          font-size: 13px;
        }
      }
    }
    .containet {
      display: flex;
      text-align: center;
      .fanhao {
        flex: 1;
        justify-content: center;
        align-items: center;
        // line-height: 50%;
        // transform: translate(50%, 50%);
        border-right: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        input {
          width: 30px;
          height: 30px;
        }
      }
      .ul {
        flex: 5;
        // background: pink;
        border-bottom: 1px solid #ccc;
        ul:nth-last-of-type(1) {
          border: 0;
        }
        ul {
          display: flex;
          height: 120px;
          justify-content: center;
          align-items: center;
          border-bottom: 1px solid #ccc;

          .img {
            position: relative;

            &:hover .img-box {
              display: block;
            }
            .img-box {
              position: absolute;
              top: 0%;
              left: 120px;
              display: none;
              z-index: 99;
            }
            .item-img {
              width: 100px;
              height: 100px;
            }
          }
          .beikao {
            position: relative;
            cursor: pointer;
            .txt {
              position: absolute;
              top: 20px;
              right: 0;
              width: 220px;
              height: 190px;
              background: #eee;
              z-index: 1;
              border: 1px solid #ccc;
              textarea {
                margin-top: 4px;
              }
              .btn {
                margin-top: 5px;
                a {
                  float: right;
                  height: 25px;
                  margin-right: 5px;
                  padding: 0 10px;
                  line-height: 25px;
                  border: 1px solid #f3c622;
                  font-size: 12px;
                  color: #f3c622;
                  border-radius: 5px;
                }
              }
            }
            img {
              width: 30px;
              height: 30px;
              margin-left: 20px;
            }
          }
        }
        input {
          width: 30px;
          height: 30px;
        }
      }
    }
    h3 {
      margin: 20px 0;
      font-size: 20px;
    }
    li {
      flex: 1;
      float: left;
      font-size: 14px;
    }
    .flex3 {
      flex: 3;
    }
  }
}
#search {
  height: 44px;
  border: 1px solid #ccc;
  .date {
    margin: 7px 0 0 10px;
  }
  .search {
    margin: 7px 10px 0 0;
    input {
      padding-left: 5px;
      border: 1px solid #ccc;
      width: 200px;
      height: 26px;
      border-radius: 5px;
    }
  }
  a {
    margin-left: 5px;
    font-size: 14px;
    color: #fff;
    display: inline-block;
    width: 50px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    border-radius: 5px;
    background-color: #f3c622;
  }
}
</style>
